<div class="inputFilter__cont">
  <app-box-filter [index]="index" [label]="label" [show]="isOpenBox" (toggleShow)="toggleOpenBox()">
    <ng-container *ngIf="isMobile; else formInput">
      <div class="input-filter">
        <div class="form-input">
          <fieldset class="input">
            <app-ds-input-search
              [isReadonly]="true"
              [placeholder]="placeholder"
              [value]="value"
              (changeEvent)="clearField()"
              (clickEvent)="toggleInputfilter()">
            </app-ds-input-search>
          </fieldset>
        </div>
      </div>
    </ng-container>
  </app-box-filter>
</div>

<ng-template #formInput>
  <div class="input-filter">
    <div class="form-input">
      <app-ds-input-search
        [value]="value"
        [placeholder]="placeholder"
        [action]="inputSearchAction"
        [quickClean]="isMobile"
        (searchEvent)="selectHotelName($event)"
        (changeEvent)="onChangeInput($event)">
      </app-ds-input-search>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isMobile">
  <app-swipe-up
    [height]="100"
    [showSwipeUp]="showSwipeUp"
    [classType]="swipeStyle"
    [useBackground]="false"
    (toggleShowSwipeUp)="toggleInputfilter()"
    [showHeader]="true"
    [title]="label">
    <ng-container content *ngIf="showSwipeUp">
      <div class="inputFilter__swipe">
        <ng-container *ngTemplateOutlet="formInput"></ng-container>
        <div class="inputFilter__swipe-list">
          <div *ngIf="showTextSearch" class="inputFilter__item" (click)="selectHotelName(value)">
            <div class="inputFilter__item-name">
              <app-ds-typography
                [size]="fontSize.XXS"
                [color]="fontColor.Secondary"
                [text]="labelBySearch | translation: { name: value }">
              </app-ds-typography>
            </div>
          </div>
          <div class="inputFilter__item" *ngFor="let value of _filterValues; let i = index" (click)="selectHotelName(value)" >
            <div class="inputFilter__item-name">
              <app-ds-typography
                [size]="fontSize.XXS"
                [color]="fontColor.Secondary"
                [text]="value">
              </app-ds-typography>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </app-swipe-up>
</ng-container>